export const phoneFrameStyles = {
  maxWidth: 420,
  maxHeight: 640,
  borderRadius: '24px',
  overflow: 'hidden',
  margin: 'auto',
  boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
  border: '8px solid #222',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 120,
    height: 12,
    borderRadius: '0 0 12px 12px',
    backgroundColor: '#222',
    zIndex: 1,
  },
};